import React, { useState } from "react";
import { FaqCards } from "./FaqCards";

export const PricingFAQ = () => {
  const FaqQuestion = [
    {
      question: "How is Gomens priced?",
      answer:
        "Gomens pricing is based on plan level and image volume, so brands can choose the option that fits their current product visual needs.",
    },
    {
      question: "Why use Gomens instead of relying only on traditional photoshoots?",
      answer:
        "Gomens helps brands create on-model product imagery faster and with less overhead. Instead of organizing another shoot for every new product or collection update, you can generate high-quality visuals from garment photos and move faster on launches.",
    },
    {
      question: "Can I test Gomens before paying for a plan?",
      answer:
        "Yes. You can start with the free plan to test Gomens on a limited number of images before upgrading.",
    },
    {
      question: "Who is Gomens pricing designed for?",
      answer:
        "Gomens is built for fashion brands, apparel sellers, retailers, and designers who need a faster way to create on-model visuals for product pages, launches, and marketing.",
    },
    {
      question: "What’s the difference between the plans?",
      answer:
        "The plans mainly differ by image volume, workflow flexibility, and support level. Higher tiers are better suited to brands with larger catalogs, more frequent launches, or a need for batch processing and more hands-on support.",
    },
    {
      question: "Does Gomens offer discounts on annual plans?",
      answer:
        "Yes. Annual plans include built-in savings compared with paying monthly.",
    },
    {
      question: "Can I use the generated images commercially?",
      answer:
        "Yes. Commercial usage is included on all plans.",
    },
    {
      question: "How does Gomens help with consistency across visuals?",
      answer:
        "Gomens helps brands create more consistent visuals across products, collections, and channels by making it easier to generate imagery within a more repeatable workflow.",
    },
    {
      question: "What is batch processing and which plans include it?",
      answer:
        "Batch processing lets you upload and process multiple garments at once instead of working one by one. It is included in the Growth plan and is especially useful for brands managing larger catalogs or higher-volume image production.",
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const handleQuestionClick = (index) => {
    // Toggle the same question or open a new one
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="  p-2 rounded-2xl bg-[#EEF2F6] w-5xl flex md:flex-row flex-col justify-between gap-4 md:gap-20 overflow-hidden">
      <section className=" bg-white flex flex-col items-center justify-center gap-6 w-[100%] rounded-lg overflow-hidden">
        {FaqQuestion.map((card, index) => (
          <FaqCards
            key={index}
            {...card}
            isActive={activeIndex === index}
            onClick={() => handleQuestionClick(index)}
            
          />
        ))}
      </section>
    </div>
  );
};
